import { Controller } from "@hotwired/stimulus"

// ネイティブ details ドロップダウンを外側クリックで閉じる
export default class extends Controller {
  connect() {
    document.addEventListener("click", this.#close)
  }

  disconnect() {
    document.removeEventListener("click", this.#close)
  }

  #close = (event) => {
    if (this.element.open && !this.element.contains(event.target)) this.element.open = false
  }
}
